<script lang="ts">
  import { push } from "svelte-spa-router";
  import { onMount } from "svelte";
  import { translation } from "../../stores";
  import { getLang } from "../../utils/window";
  import { detectAltice } from "../../utils/detectAltice";
  import CustomButton from "../Custom/CustomButton.svelte";
  import { addToast } from "../../stores/toastStore";
  import CustomInput from "../Custom/CustomInput.svelte";
  import { ROOM_CONNECTION_STATE } from "../../types/Room/RoomConnectionState";
  import { buildLog } from "../../utils/log";

  export let params: Record<string, string> = {};

  let roomId: number | null = null;
  let pin: string = "";

  let roomIsDefined = params.room !== null && params.room !== undefined;

  onMount(() => {
    detectAltice();

    if (roomIsDefined) {
      const parsed = parseInt(params.room);
      if (!isNaN(parsed)) {
        roomId = parsed;
        buildLog({
          roomId,
          status: ROOM_CONNECTION_STATE.CONNECTED,
          page: "HomeExpert",
          message: "Client connected on HomeExpert page",
        });
      }
    }
  });

  function submit(): void {
    if (!roomId) {
      addToast("error", translation.alert.roomNumberMissing);
      return;
    }

    if (!pin) {
      addToast("error", translation.alert.pinMissing);
      return;
    }
    buildLog({
      roomId,
      status: ROOM_CONNECTION_STATE.CONNECTING,
      page: "HomeExpert",
      message: `Expert is joining room ${roomId} with PIN`,
    });

    push(`/call/${roomId}?pin=${encodeURIComponent(pin)}&lang=${getLang()}&role=expert`);
  }
</script>

<p>
  {translation.intro.part1}<br /><br />
</p>
<form on:submit|preventDefault={submit}>
  {#if !roomIsDefined}
    <div class="mb-4">
      <CustomInput
        id="roomId"
        label={translation.intro.inputRoomNumber}
        type="number"
        placeholder={translation.intro.placeHolderRoomNumber}
        bind:value={roomId}
        autocomplete="off"
      />
    </div>
  {/if}

  <div class="mb-4">
    <CustomInput
      id="pin"
      label={translation.intro.inputPin}
      type="password"
      placeholder="XXXX"
      autocomplete="one-time-code"
      bind:value={pin}
    />
  </div>
  <div class="mb-1">
    <CustomButton label={translation.intro.joinRoom} onClick={submit} />
  </div>
</form>

<style>
  input::placeholder {
    color: #9ca3af;
  }
</style>
